import { Box, Typography } from '@mui/material';

import { IcCancelCircle, IcCheckCircle } from '@/assets/images';
import { getFormattedTime } from '@/utils';

import { SystemResponseItem as SystemResponseItemType } from '../types';

export const SystemResponseItem = ({
  type = 'success',
  message = 'System response message',
  date = new Date(),
}: Omit<SystemResponseItemType, 'id'>) => {
  // eslint-disable-next-line no-console

  return (
    <Box
      display="flex"
      alignItems="center"
      gap={1}
      justifyContent="space-between"
    >
      <Box display="flex" alignItems="center" gap={1}>
        {type === 'success' ? <IcCheckCircle /> : <IcCancelCircle />}
        <Typography fontSize={14} fontWeight={500}>
          {message}
        </Typography>
      </Box>
      {getFormattedTime(date.toISOString())}
    </Box>
  );
};
